import type { ReactNode } from 'react';
import { DSTypography } from '@eiv2/design-system';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="min-w-0">
        <DSTypography as="h1" className="text-[28px] font-bold tracking-tight text-dark-3 md:text-[32px]">
          {title}
        </DSTypography>
        {subtitle ? (
          <DSTypography as="p" className="mt-1 text-[14px] font-normal text-gray-5">
            {subtitle}
          </DSTypography>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
